@if (energyInterfaceState()?.isLoading) {
  <app-edit-form-skeleton />
} @else if (!energyInterfaceState() || energyInterfaceState()?.error) {
  <ui-alert color="error">
    <ng-icon name="heroXCircle" size="20" slot="icon" class="!block" />
    {{ 'cockpit.energyInterfaces.details.general.errorLoadingEnergyInterface' | transloco }}
  </ui-alert>
} @else if (energyInterfaceState()?.data) {
  @if (energyInterfaceState()?.data; as energyInterface) {
    <app-energy-interface-details-address-edit-form
      [energyInterface]="energyInterface"
      [energyInterfaceId]="energyInterfaceId()"
      [organizationId]="organizationId()"
    />
  }
}
